import restApi from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApi.post("/api/workcenter", params);
};

const upsert = data => {
  return restApi.post("/api/workcenter/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/workcenter/${ids}`);
};

const getAllForCSV = (params) => {
  return restApi.post("/api/workcenter/csv", params);
}

const workcenterService = {
  getAll,
  upsert,
  remove,
  getAllForCSV
};

export default workcenterService;